/*
  Collection of custom validation rules for trades form
*/
import {required, numeric, requiredIfFieldContains} from '../../helpr/generic-validation-rules';
import {optionsMember} from "./registration-form-validation-rules";

export const contactDetailsObj = obj => {
  return {
    fields: {
      telNo: {
        value: obj.telNo,
        style: {}
      },
      emailAddress: {
        value: obj.telNo,
        style: {}
      },
      presentAddressStreetAddress: {
        value: obj.presentAddress.streetAddress,
        style: {}
      },
      presentAddressDistrictOrTown: {
        value: obj.presentAddress.districtOrTown,
        style: {}
      },
      presentAddressCity: {
        value: obj.presentAddress.city,
        style: {}
      },
      presentAddressStateProvinceRegion: {
        value: obj.presentAddress.stateProvinceRegion,
        style: {}
      },
      presentAddressCountry: {
        value: obj.presentAddress.country,
        style: {}
      },
      presentAddressZipcode: {
        value: obj.presentAddress.zipCode,
        style: {}
      },
      permanentAddressStreetAddress: {
        value: obj.permanentAddress.streetAddress,
        style: {}
      },
      permanentAddressDistrictOrTown: {
        value: obj.permanentAddress.districtOrTown,
        style: {}
      },
      permanentAddressCity: {
        value: obj.permanentAddress.city,
        style: {}
      },
      permanentAddressStateProvinceRegion: {
        value: obj.permanentAddress.stateProvinceRegion,
        style: {}
      },
      permanentAddressCountry: {
        value: obj.permanentAddress.country,
        style: {}
      },
      permanentAddressZipcode: {
        value: obj.permanentAddress.zipCode,
        style: {}
      },
      mailingAddressStreetAddress: {
        value: obj.mailingAddress.streetAddress,
        style: {}
      },
      mailingAddressDistrictOrTown: {
        value: obj.mailingAddress.districtOrTown,
        style: {}
      },
      mailingAddressCity: {
        value: obj.mailingAddress.city,
        style: {}
      },
      mailingAddressStateProvinceRegion: {
        value: obj.mailingAddress.stateProvinceRegion,
        style: {}
      },
      mailingAddressCountry: {
        value: obj.mailingAddress.country,
        style: {}
      },
      mailingAddressZipcode: {
        value: obj.mailingAddress.zipCode,
        style: {}
      },
      statementDeliveryMode: {
        value: obj.statementDeliveryMode,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

export const contactDetailsValidator = {
  /* Set Default Values plus their respective validation rules*/
  fields: {
    telNo: [required],
    emailAddress: [required],
    presentAddressStreetAddress: [required],
    presentAddressDistrictOrTown: [required],
    presentAddressCity: [required],
    presentAddressStateProvinceRegion: [required],
    presentAddressCountry: [required],
    presentAddressZipcode: [required],
    permanentAddressStreetAddress: [required],
    permanentAddressDistrictOrTown: [required],
    permanentAddressCity: [required],
    permanentAddressStateProvinceRegion: [required],
    permanentAddressCountry: [required],
    permanentAddressZipcode: [required],
    mailingAddressStreetAddress: [required],
    mailingAddressDistrictOrTown: [required],
    mailingAddressCity: [required],
    mailingAddressStateProvinceRegion: [required],
    mailingAddressCountry: [required],
    mailingAddressZipcode: [required],
    statementDeliveryMode: [required]
  },
  dynamicFields: {}
}

